import Vue from "vue";

// setup bugsnag at top
import bugsnag from "@bugsnag/js";
import bugsnagVue from "@bugsnag/plugin-vue";
const bugsnagClient = bugsnag("4ba4ad39837cc65e3175db5ef1fcc06c");
bugsnagClient.use(bugsnagVue, Vue);

import moment from "moment";

import Vuelidate from "vuelidate";

import App from "./App.vue";
import store from "./store";
import router from "./router";

import "@/assets/css/normalize.css";
import "@/assets/css/constants.css";
import "vue-slider-component/theme/default.css";
import 'vue-select/dist/vue-select.css';
import 'vue-file-agent/dist/vue-file-agent.css';
import 'vue-plyr/dist/vue-plyr.css';

Vue.config.productionTip = false

// define global components and filters
import RumieAddress from "@/components/RumieAddress";
import RumieAlert from "@/components/RumieAlert";
import RumieContentPlaceholder from "@/components/RumieContentPlaceholder";
import RumieAnalyticsForm from "@/components/RumieAnalyticsForm";
import RumieButton from "@/components/RumieButton";
import RumieTextarea from "@/components/RumieTextarea";
import RumieCheckbox from "@/components/RumieCheckbox";
import RumieColorPicker from "@/components/RumieColorPicker";
import RumieDatepicker from "@/components/RumieDatepicker";
import RumieInput from "@/components/RumieInput";
import RumieLabel from "@/components/RumieLabel";
import RumieLoader from "@/components/RumieLoader";
import RumieTimezone from "@/components/RumieTimezone";
import RumieSelect from "vue-select";
import RumieToggleButton from "@/components/RumieToggleButton";
import RumieIconInput from "@/components/RumieIconInput";
import VueQRCodeComponent from 'vue-qrcode-component'
import VueFileAgent from 'vue-file-agent';
import VuePlyr from 'vue-plyr';

import Chart from 'chart.js';
import Notifications from "vue-notification";
import VModal from "vue-js-modal";
import VTooltip from 'v-tooltip';
import vueAwesomeCountdown from 'vue-awesome-countdown'
import VueChartkick from 'vue-chartkick';
import vueNumeralFilterInstaller from 'vue-numeral-filter';
import VueSlider from "vue-slider-component";

import ContentTree from "content-tree";
Vue.use(ContentTree);

import VueCookies from 'vue-cookies'

import { ToggleButton } from 'vue-js-toggle-button';


Vue.component("rum-address", RumieAddress);
Vue.component("rum-toggle-button", RumieToggleButton);
Vue.component("rum-alert", RumieAlert);
Vue.component("rum-analytics-form", RumieAnalyticsForm);
Vue.component("rum-button", RumieButton);
Vue.component("rum-check-box", RumieCheckbox);
Vue.component("rum-color-picker", RumieColorPicker);
Vue.component("rum-datepicker", RumieDatepicker);
Vue.component("rum-input", RumieInput);
Vue.component("rum-label", RumieLabel);
Vue.component("rum-loader", RumieLoader);
Vue.component("rum-timezone", RumieTimezone);
Vue.component("rum-select", RumieSelect);
Vue.component("rum-slider", VueSlider);
Vue.component("rum-datepicker", RumieDatepicker);
Vue.component("rum-alert", RumieAlert);
Vue.component("rum-content-placeholder", RumieContentPlaceholder);
Vue.component("rum-check-box", RumieCheckbox);
Vue.component("rum-toggle-input", ToggleButton);
Vue.component("rum-textarea", RumieTextarea);
Vue.component('rum-qr-code', VueQRCodeComponent);
Vue.component("rum-icon-input", RumieIconInput);

Vue.use(Notifications);
Vue.use(VModal, { dialog: true });
Vue.use(VTooltip);
Vue.use(vueAwesomeCountdown, "rum-countdown");
Vue.use(VueFileAgent);
Vue.use(VueChartkick, { adapter: Chart });
Vue.use(Vuelidate);
Vue.use(vueNumeralFilterInstaller);
Vue.use(VueCookies);
Vue.use(VuePlyr);

/**
 * VueChartkick.options is assigning colours for graphs.
 * There 19 (I think?) unicque colours, and then they just get repeated a few times.
 * This way of assigning colours is redicilous, but apparently it's the only way possible.
 * Because VueChartkick doesn't loop through this array when all the colours have been used,
 * I had to make it use those colours again at least for a few rounds (for huge amount of data it's still running out of colours though).
 */
VueChartkick.options = {
  colors: ['#6694f0', '#5ec261', '#ff8072', '#70c1ff', '#ffd06c', '#ffa1e1', '#8953ff', '#ff002f', '#ff9d00', '#6694f0', '#5ec261', '#ff8072', '#70c1ff', '#ffd06c', '#ffa1e1', '#8953ff', '#ff002f', '#ff9d00', '#6694f0', '#5ec261', '#ff8072', '#70c1ff', '#ffd06c', '#ffa1e1', '#8953ff', '#ff002f', '#ff9d00', '#6694f0', '#5ec261', '#ff8072', '#70c1ff', '#ffd06c', '#ffa1e1', '#8953ff', '#ff002f', '#ff9d00', '#6694f0', '#5ec261', '#ff8072', '#70c1ff', '#ffd06c', '#ffa1e1', '#8953ff', '#ff002f', '#ff9d00', '#6694f0', '#5ec261', '#ff8072', '#70c1ff', '#ffd06c', '#ffa1e1', '#8953ff', '#ff002f', '#ff9d00', '#6694f0', '#5ec261', '#ff8072', '#70c1ff', '#ffd06c', '#ffa1e1', '#8953ff', '#ff002f', '#ff9d00', '#6694f0', '#5ec261', '#ff8072', '#70c1ff', '#ffd06c', '#ffa1e1', '#8953ff', '#ff002f', '#ff9d00', '#6694f0', '#5ec261', '#ff8072', '#70c1ff', '#ffd06c', '#ffa1e1', '#8953ff', '#ff002f', '#ff9d00', '#6694f0', '#5ec261', '#ff8072', '#70c1ff', '#ffd06c', '#ffa1e1', '#8953ff', '#ff002f', '#ff9d00']
}


// Vue.component("rum-modal", VModal);

Vue.prototype.$screenType = function () {
  const width = window.innerWidth;
  if (width < 577) {
    return "mobile";
  } else {
    return "desktop";
  }
}

Vue.prototype.$copyToClipboard = function (value) {
  // make a dummy input element
  const dummy = document.createElement("input");
  // add it to the body
  document.body.appendChild(dummy);
  // set its value attribute
  dummy.setAttribute("value", value);
  // select it
  dummy.select();
  // run execCommand("copy") to copy its value
  document.execCommand("copy");
  // then remove the element
  document.body.removeChild(dummy);
}


Vue.filter("timestamp", timestamp => moment.utc(timestamp).fromNow());

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
